<template>
  <div class="content-box">
    <div class="page-title">{{title}}（{{total}}）</div>
    <page-search
      :layout="['code', 'name', 'export', 't_agent_info_agent_name']"
      @search="search"
      @exportTable="exportTable"
    ></page-search>
    <pageTable
      :loading="tableLoading"
      :col="col"
      :data="tableData"
      :total="total"
      :pageSize="pageSize"
      :pageIndex="page"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
    ></pageTable>
  </div>
</template>

<script>
import pageTable from '@/components/pageCom/pageTable.vue'
import pageTableMixin from '@/components/pageCom/pageTableMixin.js'
import pageSearch from '@/components/pageCom/pageSearch.vue'
import { AccountComfirmTrack } from '@/api/userManager'
import { addTitle } from '@/utils/common'
import { downFile } from '@/utils/file'
export default {
  name: 'verifyProgress',
  components: {
    pageSearch,
    pageTable
  },
  mixins: [pageTableMixin],
  data() {
    return {
      title: '审核进度跟踪',
      custNo: '', // 企业编码
      custName: '', // 企业名称
      t_agent_info_agent_name: '', // 渠道
      col: [
        { field: 'cust_no', title: '企业编码', width: 130, titleAlign: 'left', columnAlign: 'left', isResize: true },
        { field: 't_agent_info_agent_name', title: '渠道', width: 85, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter(rowData) {
            return addTitle(rowData['t_agent_info_agent_name'])
          }
        },
        { field: 'cust_name', title: '企业名称', width: 280, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter(rowData) {
            return addTitle(rowData['cust_name'])
          }
        },
        { field: 'cay_name', title: '认证名称', width: 280, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter(rowData) {
            return addTitle(rowData['cay_name'])
          }
        },
        { field: 'cay_comfirm_state', title: '一审状态', width: 130, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter: function(rowData) {
            if (rowData['cay_comfirm_state'] === '' || rowData['cay_comfirm_state'] === '0') {
              return '<span>未提交</span>'
            } else if (rowData['cay_comfirm_state'] === '1') {
              return '<span>审核中</span>'
            } else if (rowData['cay_comfirm_state'] === '2') {
              return '<span>一审失败</span>'
            } else if (rowData['cay_comfirm_state'] === '3') {
              return '<span>一审成功</span>'
            } else {
              return '未验证'
            }
          }
        },
        { field: 'cay_comfirm_time', title: '一审时间', width: 170, titleAlign: 'left', columnAlign: 'left', isResize: true },
        { field: 'credentialsChannel', title: '推送渠道', width: 100, titleAlign: 'left', columnAlign: 'left',
          formatter(rowData) {
            if (String(rowData['platform_flag']) === '0') {
              return '<span>天威</span>'
            } else if (String(rowData['platform_flag']) === '1') {
              return '<span>源天</span>'
            } else {
              return '<span>未绑定来源</span>'
            }
          }
        },
        { field: 'credentialsSearch', title: '证书选择', width: 100, titleAlign: 'left', columnAlign: 'left',
          formatter(rowData) {
            if (String(rowData['license_type']) === '0') {
              return '<span>UKEY</span>'
            } else if (String(rowData['license_type']) === '1') {
              return '<span>软证书</span>'
            } else {
              return '<span>未绑定类型</span>'
            }
          }
        },
        { field: 'cay_comfirm_state2', title: '二审状态', width: 130, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter: function(rowData) {
            if (rowData['cay_comfirm_state2'] === '0') {
              return '<span>未提交</span>'
            } else if (rowData['cay_comfirm_state2'] === '1') {
              return '<span>复审成功</span>'
            } else if (rowData['cay_comfirm_state2'] === '2') {
              return '<span>复审失败</span>'
            } else if (rowData['cay_comfirm_state2'] === '3') {
              return '<span style="color:#2BB968">完成审核</span>'
            } else if (rowData['cay_comfirm_state2'] === '4') {
              return '<span>审核中</span>'
            } else if (rowData['cay_comfirm_state2'] === '5') {
              return '<span style="color:#2BB968">完成审核</span>'
            } else if (rowData['cay_comfirm_state2'] === '6') {
              return ''
            } else if (rowData['cay_comfirm_state2'] === '7') {
              return '<span style="color:#2BB968">完成审核</span>'
            } else if (rowData['cay_comfirm_state2'] === '8') {
              return '<span style="color:#2BB968">完成审核</span>'
            } else if (rowData['cay_comfirm_state2'] === '9') {
              return '<span style="color:#2BB968">完成审核</span>'
            } else if (rowData['cay_comfirm_state2'] === '10') {
              return '<span style="color:#2BB968">完成审核</span>'
            } else {
              return '未提交'
            }
          }
        },
        { field: 'cay_comfirm_time2', title: '二审时间', width: 170, titleAlign: 'left', columnAlign: 'left', isResize: true },
        { field: 'cay_ordernumber', title: 'Ukey订单号', width: 240, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter(rowData) {
            return addTitle(rowData['cay_ordernumber'])
          }
        },
        { field: 'cay_status', title: '天威认证状态', width: 130, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter: function(rowData) {
            if (rowData['cay_status'] === '1') {
              return '<span>认证中或失败</span>'
            } else if (rowData['cay_status'] === '2') {
              return '<span>认证失败</span>'
            } else if (rowData['cay_status'] === '3') {
              return '<span>认证成功</span>'
            } else {
              return '<span>未认证</span>'
            }
          }
        },
        { field: 'cay_approval_opinion_tianwei', title: '天威反馈原因', width: 200, titleAlign: 'left', columnAlign: 'left', overflowTitle: true }
      ]
    }
  },
  methods: {
    initPage() {
      this.custNo = ''
      this.custName = ''
      this.t_agent_info_agent_name = ''
    },
    search(query) {
      this.custNo = query.code || ''
      this.custName = query.name || ''
      this.t_agent_info_agent_name = query.t_agent_info_agent_name || ''
      this.initTable()
      this.getData()
    },
    exportTable() {
      const url = process.env.VUE_APP_BASE_API + '/account/account_confirm_expert'
      const params = {
        cust_no: this.custNo,
        cust_name: this.custName,
        t_agent_info_agent_name: this.t_agent_info_agent_name
      }
      downFile(url, params)
    },
    getData() {
      this.tableLoading = true
      AccountComfirmTrack({
        cust_no: this.custNo,
        cust_name: this.custName,
        t_agent_info_agent_name: this.t_agent_info_agent_name,
        current_page: this.page,
        rp: this.pageSize
      }).then(res => {
        this.tableLoading = false
        const { code, result } = res
        if (code === 0) {
          this.tableData = result.data
          this.total = result.count
        } else if (res.code !== 10008) {
          this.$Message.info(res.msg)
          this.tableData = []
          this.total = 0
        }
      })
    }
  }
}
</script>

